<template>
    <ToolButton :Editor="Editor" KnownIcon="tabledeletecolumn" @ToolClick="Editor.chain().focus().deleteColumn().run()">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>